












































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { defaultImage } from '@/utils/default'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    vueCustomScrollbar,
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public fields
  @Prop({}) public selected
  @Prop({}) public imageDataCategory
  @Prop({}) public isLoading
  @Prop({}) public clearTableStatus

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }
  // Row Selected
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  // form edit
  public id: number = 0
  public name: string = ''
  public get validName(): boolean {
    return this.name.length >= 4 ? true : false
  }
  public statusTraining: boolean = true
  public statussop: boolean = true
  public carType: string = ''

  // options Form
  public optionscarType = [
    { value: 'Passenger Car', text: 'Passenger Car' },
    { value: 'Light Commercial Vehicle', text: 'Light Commercial Vehicle' },
    { value: '', text: 'SOP' },
  ]
  public statusTrainingOptions = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]
  public statussopOptions = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]

  // Method Delete Data
  public modalDelete = {
    id: 'modal-delete',
    idCategory: 0,
    categoryName: '',
  }
  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.categoryName = item.name
      this.modalDelete.idCategory = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idCategory]
    MasterCarStateDataModule.deleteMasterCar({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }

  // Method Edit Data
  public imageCoverId: any = {
    id: null,
    link: defaultImage,
  }
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public imageLogoId: any = {
    id: null,
    link: defaultImage,
  }

  public changeImageCoverId(item) {
    this.imageCoverId.id = item.id
    this.imageCoverId.link = item.link
  }
  public changeImageThumbnailId(item) {
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public changeImageLogoId(item) {
    this.imageLogoId.id = item.id
    this.imageLogoId.link = item.link
  }

  public cancelImageThumbnailId() {
    this.stateThumbnailImage = false
    this.imageThumbnailId.link = ''
  }
  public cancelImageCoverId() {
    this.stateCoverImage = false
    this.imageCoverId.link = ''
  }
  public cancelImageLogoId() {
    this.stateLogoImage = false
    this.imageLogoId.link = ''
  }

  // image state
  public stateCoverImage = false
  public stateThumbnailImage = false
  public stateLogoImage = false
  public previousImageCover: any = null
  public previousImageLogo: any = null
  public previousImageThumbnail: any = null

  public funcEdit(item) {
    if (this.$props.selected.length < 1) {
      if (item.imageCover.link !== '') {
        this.previousImageCover = { ...item.imageCover }
      }
      if (item.imageThumbnail.link !== '') {
        this.previousImageThumbnail = { ...item.imageThumbnail }
      }
      if (item.imageLogo.link !== '') {
        this.previousImageLogo = { ...item.imageLogo }
      }

      this.id = item.id
      this.name = item.name
      this.statusTraining = item.trainingStatus
      this.statussop = item.sopStatus
      this.carType = item.tag
      this.imageCoverId = item.imageCover
      this.imageThumbnailId = item.imageThumbnail
      this.imageLogoId = item.imageLogo
      this.$root.$emit('bv::show::modal', 'edit-data')
    }
  }

  public funcEditData() {
    if (this.validName === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        name: this.name,
        trainingActive: this.statusTraining,
        sopActive: this.statussop,
        imageCoverId:
          this.imageCoverId.id === undefined
            ? this.imageCoverId.image_id
            : this.imageCoverId.id,
        imageThumbnailId:
          this.imageThumbnailId.id === undefined
            ? this.imageThumbnailId.image_id
            : this.imageThumbnailId.id,
        imageLogoId:
          this.imageLogoId.id === undefined
            ? this.imageLogoId.image_id
            : this.imageLogoId.id,
        tag: this.carType,
      }
      MasterCarStateDataModule.updateMasterCar(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'edit-data')
    }
  }
  public resetEditModal() {
    this.id = 0
    this.name = ''
    this.statusTraining = true
    this.statussop = true
    this.carType = ''
    this.cancelImageThumbnailId()
    this.cancelImageCoverId()
    this.cancelImageLogoId()
  }

  public previewMaster = {
    id: 'preview-image',
    imageCar: '',
  }
  public funcPreview(item, button) {
    if (this.$props.selected.length < 1) {
      //  console.log('item', item)

      this.previewMaster.imageCar = item
      this.$root.$emit('bv::show::modal', this.previewMaster.id, button)
    }
  }
}
